<template>
  <div class="not-found">
    <h1>Page not found</h1>
    <p>Oops. The page you are looking for, is currently doesn't exists...</p>
    <img src="../assets/images/404.png" alt="404 page" style="max-width: 100%;">
    <p class="small-text">We are so sorry!</p>
    <button class="btn btn-blue" v-on:click="nextToProfile">Back to profile</button>
  </div>
</template>

<script>
    export default {
        name: "NotFound",
        methods: {
            nextToProfile() {
                this.$router.push({
                    name: 'Profile'
                })
            }
        }
    }
</script>

<style lang="scss">
</style>
